module.exports = __webpack_public_path__ + "static/media/icon_collapse_wht.d2e9644a.svg";